import _ from 'lodash';

import APIClient from '../lib/APIClient';
import Fare from '../records/Fare';
import { resolveAll } from '../helpers/LinkMapper';
import PromoCodeStore from '../stores/PromoCodeStore';
import FeatureFlagStore from '../stores/FeatureFlagStore';
import { JOB_CENTRE_PLUS_RAILCARD_CODE } from '../constants/AppConstants';

const getDurations = function (search) {
    let durations = [];
    if (FeatureFlagStore.get('enableFlexiSeasonTickets') && search.flexi) { durations.push('FLEXI'); }
    if (FeatureFlagStore.get('enableWeeklySeasonTickets') && search.weekly) { durations.push('P7D'); }
    if (FeatureFlagStore.get('enableFourWeeklySeasonTickets') && search.fourWeekly && search.smartcard) { durations.push('P28D'); }
    if (search.monthly) { durations.push('P1M'); }
    if (FeatureFlagStore.get('enableQuarterlySeasonTickets') && search.quarterly) { durations.push('P3M'); }
    if (FeatureFlagStore.get('enableSixMonthlySeasonTickets') && search.sixMonthly) { durations.push('P6M'); }
    if (search.annual) { durations.push('P12M'); }

    if (search.custom) { durations.push(search.dates.formatDuration()); }

    return durations;
};

const SeasonTicketsService = {

    async search (search, user) {
        const url = '/jp/season-tickets';

        let requestBody = {
            origin: search.origin.nlc,
            destination: search.destination.nlc,
            startDate: search.dates.getStartDate().format('YYYY-MM-DD'),
            duration: getDurations(search),
            adult: search.isAdult()
        };

        if (search.smartcard && user) {
            Object.assign(requestBody, {
                adult: user.isAdult()
            });
        }

        const railcardJobCentrePlus = search.get('railcardJobCentrePlus');

        let railcards = [];

        if (search.railcard1617 && search.railcard1617.isValid() && user) {
            railcards.push(search.railcard1617.get('railcardCode'));
        }

        if (user && railcardJobCentrePlus) {
            railcards.push(JOB_CENTRE_PLUS_RAILCARD_CODE);
        }
        requestBody = {
            ...requestBody,
            railcards: _.isEmpty(railcards) ? null : railcards
        };

        const promo = !search.promoCode.isEmpty() ? search.promoCode : PromoCodeStore.getActive();

        if (promo) {
            requestBody.promoCode = promo.promoCode;
        }

        if (search.orderId) {
            requestBody.orderId = search.orderId;
        }

        let response;
        try {
            response = await APIClient.post(url, requestBody);
        } catch (error) {
            if (_.result(error, 'body.result', []).length) {
                console.error('Supressing error', error);
                response = error.body;
            } else {
                throw error;
            }
        }
        const faresResult = _.result(response, 'result', []);
        const fares = resolveAll(faresResult).as(Fare);
        return fares.sortBy((fare) => fare.getPrice());
    }
};

export default SeasonTicketsService;
